import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const packingPackage = createAction(ACTION.PACKING_PACKAGE.REQUEST);
export const updateWeightReal = createAction(ACTION.UPDATE_WEIGHT_REAL.REQUEST);